import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { changeTablesQrCode } from "../../../../services/Admin/TablesApi";

const ChangeTableQrDialog = ({ open, onClose, onChanged, initialFrom, initialTo, initialFromName, initialToName }) => {
  const [fromId, setFromId] = useState(initialFrom ?? "");
  const [toId, setToId] = useState(initialTo ?? "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setFromId(initialFrom ?? "");
      setToId(initialTo ?? "");
      setError(null);
    }
  }, [open, initialFrom, initialTo]);

  const handleClose = () => {
    if (!loading) {
      onClose && onClose();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const f = Number(fromId);
    const t = Number(toId);
    if (!Number.isFinite(f) || f <= 0 || !Number.isInteger(f)) {
      setError("يرجى إدخال رقم جدول صالح في الحقل الأول");
      return;
    }
    if (!Number.isFinite(t) || t <= 0 || !Number.isInteger(t)) {
      setError("يرجى إدخال رقم جدول صالح في الحقل الثاني");
      return;
    }

    setLoading(true);
    try {
      const res = await changeTablesQrCode(f, t);
      onChanged && onChanged(res?.data ?? res);
      onClose && onClose();
    } catch (err) {
      setError(err?.message || "حدث خطأ أثناء تغيير رمز QR للطاولات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>تغيير QR للطاولات</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            أدخل معرف الجدول الذي سيتم نقل QR منه وإلى أي جدول.
          </Typography>

          <TextField
            margin="dense"
            label="من جدول (from_table_id)"
            type="number"
            fullWidth
            inputProps={{ min: 1 }}
            value={fromId}
            onChange={(e) => setFromId(e.target.value)}
            disabled={loading}
          />
          {initialFromName && (
            <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
              اسم: {initialFromName}
            </Typography>
          )}

          <TextField
            margin="dense"
            label="إلى جدول (to_table_id)"
            type="number"
            fullWidth
            inputProps={{ min: 1 }}
            value={toId}
            onChange={(e) => setToId(e.target.value)}
            disabled={loading}
          />
          {initialToName && (
            <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
              اسم: {initialToName}
            </Typography>
          )}

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            إلغاء
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "تغيير"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangeTableQrDialog;
